
복사

<template>
  <div id="sub-asso">
 
    <!-- ======================== 코브랜드 히어로 ======================== -->
    <header class="asso-hero">
      <div class="hero-grid-pattern"></div>
      <div class="container">
        <div class="hero-inner">
 
          <!-- 브랜드 콜라보 로고 -->
          <div class="collab-logos">
            <img src="../assets/img/asso/jin.png" class="logo-jin" alt="진에어" />
            <div class="collab-x">
              <!-- <span>&</span> -->
              <i class="bi bi-feather fs-5 fw-bold text-white"></i>
            </div>
            <img src="../assets/img/asso/nd.png" class="logo-nd" alt="엔타비" />
          </div>
 
          <!-- 헤드라인 -->
          <div class="hero-headline">
            <span class="hero-tag">SPECIAL COLLABORATION</span>
            <h1 class="hero-title">추천 일본·대만<br>버스투어 <em>특가!</em></h1>
            <p class="hero-sub">진에어와 함께하는 엔타비글로벌의 엄선된 현지투어</p>
          </div>
 
          <!-- 출발지 칩 -->
          <div class="hero-chips">
            <a href="#jp_sap"><span class="hero-chip" v-if="this.pG_sap.length > 0"><i class="bi bi-geo-fill"></i> 삿포로</span></a>
            <a href="#jp_fuk"><span class="hero-chip" v-if="this.pG_fuk.length > 0"><i class="bi bi-geo-fill"></i> 후쿠오카</span></a>
            <a href="#jp_osa"><span class="hero-chip" v-if="this.pG_osa.length > 0"><i class="bi bi-geo-fill"></i> 오사카</span></a>
            <a href="#jp_nag"><span class="hero-chip" v-if="this.pG_nag.length > 0"><i class="bi bi-geo-fill"></i> 나고야</span></a>
            <a href="#jp_tok"><span class="hero-chip" v-if="this.pG_tok.length > 0"><i class="bi bi-geo-fill"></i> 도쿄</span></a>
            <a href="#jp_kit"><span class="hero-chip" v-if="this.pG_kit.length > 0"><i class="bi bi-geo-fill"></i> 기타큐슈</span></a>
            <a href="#tw_taw"><span class="hero-chip hero-chip-tw" v-if="this.pG_taw.length > 0"><i class="bi bi-geo-fill"></i> 대만</span></a>
          </div>
 
        </div>
      </div>
      <!-- 하단 웨이브 -->
      <div class="hero-wave">
        <svg viewBox="0 0 1440 70" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0,35 C360,70 720,0 1080,35 C1260,52 1380,28 1440,35 L1440,70 L0,70 Z" fill="#f5f6f2"/>
        </svg>
      </div>
    </header>
 
 
    <!-- ======================== 상품 섹션 ======================== -->
    <section id="pack" class="packages">
      <div class="container">
        <div class="packages-content">
          <div class="row gx-4">
            <div class="1step mt-4 mb-5">
 
              <!-- ---- 삿포로 ---- -->
              <div id="jp_sap" class="city-group" v-if="this.pG_sap.length > 0">
                <div class="city-header">
                  <div class="city-dot"></div>
                  <span class="city-name">삿포로</span>
                  <span class="city-en">Sapporo</span>
                  <div class="city-line"></div>
                </div>
                <div class="card-scroll-wrap">
                  <div class="asso-card" :key="j" v-for="(nd, j) in this.pG_sap">
                    <div class="card-pic" @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                      <div class="card-overlay">
                        <span class="overlay-cta">투어 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                      <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img" alt="..." />
                      <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img" />
                      <div class="badge-wrap">
                        <div v-if="nd.badgeFlag === 'Y'">
                          <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                        </div>
                        <div v-else></div>
                      </div>
                      <!-- 특가 리본 -->
                      <!-- <div class="special-ribbon">진에어 특가</div> -->
                    </div>
                    <div class="card-body">
                      <div class="pdtName">{{ nd.pdtNameKor }}</div>
                      <div class="pdtRemarks"><i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}</div>
                      <div class="card-price-wrap">
                        <div v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                             @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                          <span class="price-original">{{ getCurrencyFormat(nd.pdtPrice) }}원</span>
                          <div class="price-final">
                            {{ getCurrencyFormat(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))-(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))*(nd.asso_DCRate))/100) }}
                            <span class="price-won">원~</span>
                          </div>
                        </div>
                        <div class="preparing-wrap" v-else>
                          <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                          <span class="preparing-text">준비 중</span>
                          <i class="bi bi-question-circle-fill text-danger ms-1"
                             style="cursor:pointer; font-size:.85rem"
                             @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
 
              <!-- ---- 후쿠오카 ---- -->
              <div id="jp_fuk" class="city-group" v-if="this.pG_fuk.length > 0">
                <div class="city-header">
                  <div class="city-dot"></div>
                  <span class="city-name">후쿠오카</span>
                  <span class="city-en">Fukuoka</span>
                  <div class="city-line"></div>
                </div>
                <div class="card-scroll-wrap">
                  <div class="asso-card" :key="j" v-for="(nd, j) in this.pG_fuk">
                    <div class="card-pic" @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                      <div class="card-overlay">
                        <span class="overlay-cta">투어 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                      <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img" alt="..." />
                      <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img" />
                      <div class="badge-wrap">
                        <div v-if="nd.badgeFlag === 'Y'">
                          <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                        </div>
                        <div v-else></div>
                      </div>
                      <!-- <div class="special-ribbon">진에어 특가</div> -->
                    </div>
                    <div class="card-body">
                      <div class="pdtName">{{ nd.pdtNameKor }}</div>
                      <div class="pdtRemarks"><i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}</div>
                      <div class="card-price-wrap">
                        <div v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                             @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                          <span class="price-original">{{ getCurrencyFormat(nd.pdtPrice) }}원</span>
                          <div class="price-final">
                            {{ getCurrencyFormat(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))-(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))*(nd.asso_DCRate))/100) }}
                            <span class="price-won">원~</span>
                          </div>
                        </div>
                        <div class="preparing-wrap" v-else>
                          <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                          <span class="preparing-text">준비 중</span>
                          <i class="bi bi-question-circle-fill text-danger ms-1"
                             style="cursor:pointer; font-size:.85rem"
                             @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
 
              <!-- ---- 오사카 ---- -->
              <div id="jp_osa" class="city-group" v-if="this.pG_osa.length > 0">
                <div class="city-header">
                  <div class="city-dot"></div>
                  <span class="city-name">오사카</span>
                  <span class="city-en">Osaka</span>
                  <div class="city-line"></div>
                </div>
                <div class="card-scroll-wrap">
                  <div class="asso-card" :key="j" v-for="(nd, j) in this.pG_osa">
                    <div class="card-pic" @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                      <div class="card-overlay">
                        <span class="overlay-cta">투어 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                      <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img" alt="..." />
                      <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img" />
                      <div class="badge-wrap">
                        <div v-if="nd.badgeFlag === 'Y'">
                          <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                        </div>
                        <div v-else></div>
                      </div>
                      <!-- <div class="special-ribbon">진에어 특가</div> -->
                    </div>
                    <div class="card-body">
                      <div class="pdtName">{{ nd.pdtNameKor }}</div>
                      <div class="pdtRemarks"><i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}</div>
                      <div class="card-price-wrap">
                        <div v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                             @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                          <span class="price-original">{{ getCurrencyFormat(nd.pdtPrice) }}원</span>
                          <div class="price-final">
                            {{ getCurrencyFormat(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))-(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))*(nd.asso_DCRate))/100) }}
                            <span class="price-won">원~</span>
                          </div>
                        </div>
                        <div class="preparing-wrap" v-else>
                          <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                          <span class="preparing-text">준비 중</span>
                          <i class="bi bi-question-circle-fill text-danger ms-1"
                             style="cursor:pointer; font-size:.85rem"
                             @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
 
              <!-- ---- 나고야 ---- -->
              <div id="jp_nag" class="city-group" v-if="this.pG_nag.length > 0">
                <div class="city-header">
                  <div class="city-dot"></div>
                  <span class="city-name">나고야</span>
                  <span class="city-en">Nagoya</span>
                  <div class="city-line"></div>
                </div>
                <div class="card-scroll-wrap">
                  <div class="asso-card" :key="j" v-for="(nd, j) in this.pG_nag">
                    <div class="card-pic" @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                      <div class="card-overlay">
                        <span class="overlay-cta">투어 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                      <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img" alt="..." />
                      <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img" />
                      <div class="badge-wrap">
                        <div v-if="nd.badgeFlag === 'Y'">
                          <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                        </div>
                        <div v-else></div>
                      </div>
                      <!-- <div class="special-ribbon">진에어 특가</div> -->
                    </div>
                    <div class="card-body">
                      <div class="pdtName">{{ nd.pdtNameKor }}</div>
                      <div class="pdtRemarks"><i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}</div>
                      <div class="card-price-wrap">
                        <div v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                             @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                          <span class="price-original">{{ getCurrencyFormat(nd.pdtPrice) }}원</span>
                          <div class="price-final">
                            {{ getCurrencyFormat(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))-(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))*(nd.asso_DCRate))/100) }}
                            <span class="price-won">원~</span>
                          </div>
                        </div>
                        <div class="preparing-wrap" v-else>
                          <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                          <span class="preparing-text">준비 중</span>
                          <i class="bi bi-question-circle-fill text-danger ms-1"
                             style="cursor:pointer; font-size:.85rem"
                             @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
 
              <!-- ---- 도쿄 ---- -->
              <div id="jp_tok" class="city-group" v-if="this.pG_tok.length > 0">
                <div class="city-header">
                  <div class="city-dot"></div>
                  <span class="city-name">도쿄</span>
                  <span class="city-en">Tokyo</span>
                  <div class="city-line"></div>
                </div>
                <div class="card-scroll-wrap">
                  <div class="asso-card" :key="j" v-for="(nd, j) in this.pG_tok">
                    <div class="card-pic" @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                      <div class="card-overlay">
                        <span class="overlay-cta">투어 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                      <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img" alt="..." />
                      <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img" />
                      <div class="badge-wrap">
                        <div v-if="nd.badgeFlag === 'Y'">
                          <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                        </div>
                        <div v-else></div>
                      </div>
                      <!-- <div class="special-ribbon">진에어 특가</div> -->
                    </div>
                    <div class="card-body">
                      <div class="pdtName">{{ nd.pdtNameKor }}</div>
                      <div class="pdtRemarks"><i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}</div>
                      <div class="card-price-wrap">
                        <div v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                             @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                          <span class="price-original">{{ getCurrencyFormat(nd.pdtPrice) }}원</span>
                          <div class="price-final">
                            {{ getCurrencyFormat(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))-(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))*(nd.asso_DCRate))/100) }}
                            <span class="price-won">원~</span>
                          </div>
                        </div>
                        <div class="preparing-wrap" v-else>
                          <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                          <span class="preparing-text">준비 중</span>
                          <i class="bi bi-question-circle-fill text-danger ms-1"
                             style="cursor:pointer; font-size:.85rem"
                             @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
 
              <!-- ---- 기타큐슈 ---- -->
              <div id="jp_kit" class="city-group" v-if="this.pG_kit.length > 0">
                <div class="city-header">
                  <div class="city-dot"></div>
                  <span class="city-name">기타큐슈</span>
                  <span class="city-en">Kitakyushu</span>
                  <div class="city-line"></div>
                </div>
                <div class="card-scroll-wrap">
                  <div class="asso-card" :key="j" v-for="(nd, j) in this.pG_kit">
                    <div class="card-pic" @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                      <div class="card-overlay">
                        <span class="overlay-cta">투어 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                      <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img" alt="..." />
                      <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img" />
                      <div class="badge-wrap">
                        <div v-if="nd.badgeFlag === 'Y'">
                          <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                        </div>
                        <div v-else></div>
                      </div>
                      <!-- <div class="special-ribbon">진에어 특가</div> -->
                    </div>
                    <div class="card-body">
                      <div class="pdtName">{{ nd.pdtNameKor }}</div>
                      <div class="pdtRemarks"><i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}</div>
                      <div class="card-price-wrap">
                        <div v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                             @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                          <span class="price-original">{{ getCurrencyFormat(nd.pdtPrice) }}원</span>
                          <div class="price-final">
                            {{ getCurrencyFormat(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))-(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))*(nd.asso_DCRate))/100) }}
                            <span class="price-won">원~</span>
                          </div>
                        </div>
                        <div class="preparing-wrap" v-else>
                          <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                          <span class="preparing-text">준비 중</span>
                          <i class="bi bi-question-circle-fill text-danger ms-1"
                             style="cursor:pointer; font-size:.85rem"
                             @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
 
              <!-- ---- 대만 ---- -->
              <div id="tw_taw" class="city-group city-group-tw" v-if="this.pG_taw.length > 0">
                <div class="city-header">
                  <div class="city-dot city-dot-tw"></div>
                  <span class="city-name">대만</span>
                  <span class="city-en">Taiwan</span>
                  <div class="city-line"></div>
                </div>
                <div class="card-scroll-wrap">
                  <div class="asso-card" :key="j" v-for="(nd, j) in this.pG_taw">
                    <div class="card-pic" @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                      <div class="card-overlay">
                        <span class="overlay-cta">투어 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                      <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img" alt="..." />
                      <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img" />
                      <div class="badge-wrap">
                        <div v-if="nd.badgeFlag === 'Y'">
                          <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                        </div>
                        <div v-else></div>
                      </div>
                      <!-- <div class="special-ribbon special-ribbon-tw">진에어 특가</div> -->
                    </div>
                    <div class="card-body">
                      <div class="pdtName">{{ nd.pdtNameKor }}</div>
                      <div class="pdtRemarks"><i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}</div>
                      <div class="card-price-wrap">
                        <div v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                             @click="goToDetail(nd.pdtCode, nd.salesRoute, nd.assoFlag)" style="cursor:pointer">
                          <span class="price-original">{{ getCurrencyFormat(nd.pdtPrice) }}원</span>
                          <div class="price-final">
                            {{ getCurrencyFormat(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))-(((nd.basic_PdtPrice*1)+(nd.minOptPrice*1))*(nd.asso_DCRate))/100) }}
                            <span class="price-won">원~</span>
                          </div>
                        </div>
                        <div class="preparing-wrap" v-else>
                          <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                          <span class="preparing-text">준비 중</span>
                          <i class="bi bi-question-circle-fill text-danger ms-1"
                             style="cursor:pointer; font-size:.85rem"
                             @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
 
            </div>
          </div>
        </div>
      </div>
    </section>
 
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      ntToAr: {},                   //버스투어가능국가지역
      ntToAr_jp: [],                //일본내 버스투어가능지역
      ntToAr_etc: [],               //버스투어가능 국가와 지역
      nt: "",                       //상품카테고리(국가기준)
      ar: "",                       //상품카테고리(지역기준)
      sellerCode: "ND",             //판매자코드

      productListForSales_org: [],  //로컬전체상품
      productListForSales: [],      //판매상품리스트
      etc_more: "N",                //일본외 더보기

      //showLayer: false,           //지역(국가)선택레이어

      natName: "",                      //표시페이지 국가명
      selectableNation: [],             //선택가능 국가

      nationList: {},                   //여행지역리스트
      pdtCatList: {},                   //상품카테고리
      
      productListForSales_recomend: {}, //추천상품리스트
      // pPriceY: 0,
      // pPriceN: 0,
      // pPriceE: 0,
      
      //dispPrice: [],        //가격표시방법(mem / promo)

      //promoPrice: 0,        //프로모션할인액

      //상품그룹(지역별: 진에어 요구사항)
      pG_sap: [],           //삿포로   (5~19) 
      pG_fuk: [],           //후쿠오카 (20~24)     
      pG_osa: [],           //오사카   (25~29)     
      pG_nag: [],           //나고야   (30~34)     
      pG_tok: [],           //도쿄     (35~39)     
      pG_kit: [],           //기타큐슈 (40~44)
      pG_taw: [],           //타이완   (80~90)
    };
  },
  created() {
    // 페이지생성과 동시에 리스트정보를 get
		this.nt = (this.$route.query.nt == undefined) ? "%" : this.$route.query.nt;
    this.ar = (this.$route.query.ar == undefined) ? "%" : this.$route.query.ar;
		this.sellerCode = (this.$route.query.sc === undefined) ? "ND" : this.$route.query.sc;
    this.assoFlag = this.$route.query.assoFlag
    //console.log("assoFlag: ", this.assoFlag)

    // this.getProductList();

    this.getProductList_new();
    this.getNationList();
    this.getBustourArea();
  },
  mounted() {
    if(this.assoFlag == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'warning').then(() => {
        location.replace("https://ntabi.co.kr");
      })
    }

    //상세정보와 무관한 내용 비표시처리
    document.getElementById("user").style.display = "none";
    document.getElementById("userM").style.display = "none";
    ////document.getElementById("notice").style.display = "none";

    //페이지뷰 카운팅
    this.countPageView(this.assoFlag, this.assoFlag)
  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      // 로그인전: bId정보없음, 로그인후: bId정보있음
      return this.$store.state.user;
    }
  },  
  methods: {
    async countPageView(pdtCode, fAssoFlag){
      let vParam = "V"
      let countPageView = await this.$api("/api/proc_countPageView", {param:[ pdtCode, fAssoFlag, vParam ]})
      if(countPageView.affectedRows > 0)
      {
        console.log("We appreciate for your visiting!")
      }
    },


    getImageUrl(flag) {
      try {
        // require를 사용하여 동적으로 이미지 로드
        return require(`@/assets/img/asso/${flag}.png`);
      } catch (error) {
        console.error("이미지를 찾을 수 없습니다:", error);
        return ''; // 이미지가 없을 경우 대체 이미지 경로 또는 빈 문자열 반환
      }
    },

    async getNationList() 
    {
      let nationList = await this.$api("/api/nationList", {});
      this.nationList = nationList;
      
      let natName = nationList.filter((item) => {
        return item.baseCode == this.nt
      })
      this.natName = natName.codeNameKor
      //console.log("nationList:",this.nationList,",natName:",this.natName)
    },

    //선택가능한 버스투어 지역정보
    async getBustourArea() {
      let bustourArea = await this.$api("/api/getBustourArea_asso", {param:[this.assoFlag]})

      //console.log("bustourArea:", bustourArea)

      let ntToAr = {}

      if(bustourArea.length > 0)
      {
        this.bustourArea = bustourArea
        //국가별 지역으로 정리
        bustourArea.forEach(item => {
          if(!ntToAr[item.ntCd])
          {
            ntToAr[item.ntCd] = [];
          }
          ntToAr[item.ntCd].push({
            ntCd: item.ntCd,
            arCd: item.arCd,
            NT: item.NT,
            AR: item.AR
          })
        })
      }
      this.ntToAr = ntToAr
    },


    // mixins에 있는 공통함수 호출샘플
    /** 자릿수 표시 */
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    /** 개행처리 */
    getStringFormat(text) {
      return this.$stringFormat(text);
    },
		/** 일자처리 */
    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },

    // 신가격정책이 적용된 상품리스트
    async getProductList_new() 
    {
      // let ntCd = this.nt
      // let arCd = this.ar
      //let sRoute = "L";
      // let sMinPrice = 0;
      // let sMargin = 0;

      //console.log("ntCd:",ntCd,"arCd:",arCd);

      // 전체로컬상품추출 후, 연계상품제외 (진에어)
      // let productListForSales_tmptmp = await this.$api("/api/product_localtour_m", {param: [sRoute]});
      let productListForSales_tmptmp = await this.$api("/api/product_localtour_m_new", {});
      let productListForSales_tmp = productListForSales_tmptmp.filter((item) => {
        return (item.assoFlag == "lj")
        // return (item.assoFlag != null || item.assoFlag != "" || item.assoFlag != undefined)
      })
      
      if(productListForSales_tmp.length > 0) 
      {
        this.productListForSales_org = productListForSales_tmp    //로컬전체상품(org)
      }
      
      // console.log("productListForSales_org: ", this.productListForSales_org)

			//엔데트립 상품만 추출
			if(this.sellerCode === 'ND')
			{
				let productListForSales_ndaytrip1 = this.productListForSales_org.filter((item) => 
				{
					return item.sellerCode_nd == "Y";
				});

        let productListForSales_ndaytrip = productListForSales_ndaytrip1.sort((a, b) => {
          if (a.ntCd == 'JP' && b.ntCd != 'JP') 
          {
            return -1;
          } 
          else if (a.ntCd != 'JP' && b.ntCd === 'JP') 
          {
            return 1;
          } 
          else if (a.ntCd < b.ntCd) 
          {
            return -1;
          } 
          else if (a.ntCd > b.ntCd) 
          {
            return 1;
          } 
          else 
          {
            return 0;
          }
        });
        
				this.productListForSales = productListForSales_ndaytrip;
        //console.log("productListForSales: ", this.productListForSales )


        this.pG_sap = this.productListForSales.filter((item) => {
          return item.sortNo >= 5 && item.sortNo < 20
        })

        this.pG_fuk = this.productListForSales.filter((item) => {
          return item.sortNo >= 20 && item.sortNo < 25
        })

        this.pG_osa = this.productListForSales.filter((item) => {
          return item.sortNo >= 25 && item.sortNo < 30
        })

        this.pG_nag = this.productListForSales.filter((item) => {
          return item.sortNo >= 30 && item.sortNo < 35
        })

        this.pG_tok = this.productListForSales.filter((item) => {
          return item.sortNo >= 35 && item.sortNo < 40
        })

        this.pG_kit = this.productListForSales.filter((item) => {
          return item.sortNo >= 40 && item.sortNo < 45
        })

        //타이완 추가
        this.pG_taw = this.productListForSales.filter((item) => {
          return item.sortNo >= 80 && item.sortNo < 90
        })

        //console.log("pG_sap:>>>", this.pG_sap, "//pG_nag:::::", this.pG_nag)

			}
    },

    // 상품문의
    inquiryProduct(pCode, sRoute) {
      this.$router.push({path: '/inquiryProduct', query: {productId: pCode, salesRoute:sRoute}});
    },

    showEtcSelArea(param) {
      if(param === 'all') 
      {
        //document.querySelector('.more-etc').style.display = 'block'
        // document.querySelector('.more-etc').classList.add('initial-state');
        this.productListForSales = this.productListForSales_org.slice(0,6)
      }
      else
      {
        //document.querySelector('.more-etc').style.display = "none"
        let productListForSales_tmp = this.productListForSales_org.filter(item => {
          return item.ntCd === param
        })

        this.productListForSales = productListForSales_tmp.slice(0,6)
      }
    },

    goToDetail(productId, salesRoute, assoFlag) {
      this.$router.push({path: '/productDetail_asso', query: {productId: productId, salesRoute:salesRoute, asso:assoFlag}});
    },
    // 숫자콤마표시
    // getCurrencyFormat(value) {
    //   // console.log('value' + value)
    //   return (value+"").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap');
 
/* ================================================
  # CSS 변수 — 진에어 × 엔타비 코브랜드 테마
  진에어: #C8E03A (라임옐로) / 엔타비: #86cd53 (라임그린)
  두 브랜드 모두 라임 계열 → 그라디언트로 코브랜딩
================================================ */
#sub-asso {
  --jin-lime:      #C8E03A;
  --jin-lime-dark: #a8bc20;
  --nd-green:      #86cd53;
  --nd-green-dark: #6ab53e;
  --charcoal:      #111418;
  --charcoal-soft: #1e2328;
  --gray-50:       #f5f6f2;
  --gray-100:      #eef0ea;
  --gray-200:      #dde0d8;
  --gray-400:      #9aa097;
  --gray-600:      #5a5f58;
  --text-main:     #111418;
  --text-sub:      #5a5f58;
  --radius-sm:     6px;
  --radius-md:     14px;
  --shadow-sm:     0 2px 10px rgba(17,20,24,0.07);
  --shadow-md:     0 8px 32px rgba(17,20,24,0.14);
 
  background: var(--gray-50);
}
 
 
/* ================================================
  # 히어로
================================================ */
.asso-hero {
  position: relative;
  background: var(--charcoal);
  padding: 5rem 0 5rem;
  overflow: hidden;
}
 
/* 그리드 패턴 배경 */
.hero-grid-pattern {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(200,224,58,0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(200,224,58,0.06) 1px, transparent 1px);
  background-size: 40px 40px;
  pointer-events: none;
}
/* 그라디언트 빛 */
.asso-hero::before {
  content: '';
  position: absolute;
  top: -80px;
  right: -80px;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(200,224,58,0.15) 0%, transparent 70%);
  pointer-events: none;
}
 
/* 하단 웨이브 */
.hero-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  line-height: 0;
}
.hero-wave svg { display: block; width: 100%; height: 55px; }
 
.hero-inner {
  position: relative;
  z-index: 1;
  text-align: center;
}
 
/* 로고 영역 */
.collab-logos {
  display: inline-flex;
  align-items: center;
  gap: 1.5rem;
  /* background: rgba(255,255,255,0.05); */
  background: white;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 50px;
  padding: 0.8rem 2rem;
  margin-bottom: 2rem;
  backdrop-filter: blur(6px);
}
.logo-jin {
  height: 2rem;
  width: auto;
  filter: brightness(1.1);
}
.logo-nd {
  height: 1.6rem;
  width: auto;
  filter: brightness(1.1);
}
.collab-x {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  /* background: linear-gradient(135deg, var(--jin-lime), var(--nd-green)); */
  background: linear-gradient(135deg, var(--jin-lime), var(--nd-green-dark));
  display: flex;
  align-items: center;
  justify-content: center;
}
.collab-x span {
  font-size: 1rem;
  font-weight: 900;
  color: var(--charcoal);
  line-height: 1;
}
 
/* 헤드라인 */
.hero-headline { margin-bottom: 2rem; }
.hero-tag {
  display: inline-block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 3.5px;
  color: var(--jin-lime);
  margin-bottom: 0.8rem;
}
.hero-title {
  font-family: 'Black Han Sans', sans-serif;
  font-size: 3.2rem;
  color: #fff;
  line-height: 1.15;
  margin-bottom: 0.7rem;
  letter-spacing: -1px;
}
.hero-title em {
  font-style: normal;
  background: linear-gradient(90deg, var(--jin-lime), var(--nd-green));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.hero-sub {
  font-size: 0.95rem;
  color: rgba(255,255,255,0.5);
  margin: 0;
}
 
/* 출발지 칩 */
.hero-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}
.hero-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: rgba(255,255,255,0.7);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 20px;
  padding: 5px 14px;
  background: rgba(255,255,255,0.05);
  transition: all 0.2s;
}
.hero-chip i { color: var(--jin-lime); font-size: 0.7rem; }
.hero-chip-tw i { color: var(--nd-green); }
 
@media (max-width: 767px) {
  .asso-hero { padding: 6rem 0 4.5rem; }
  .hero-title { font-size: 2.2rem; }
  .collab-logos { padding: 0.6rem 1.2rem; gap: 1rem; }
  .logo-jin { height: 1.6rem; }
  .logo-nd { height: 1.3rem; }
}
 
 
/* ================================================
  # 상품 섹션
================================================ */
.packages { margin: 0; padding: 3rem 0 6rem; }
 
 
/* ================================================
  # 도시 그룹 헤더
================================================ */
.city-group {
  margin-bottom: 3.5rem;
}
.city-header {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-bottom: 1.4rem;
}
.city-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--jin-lime), var(--nd-green));
  flex-shrink: 0;
  box-shadow: 0 0 0 3px rgba(200,224,58,0.2);
}
.city-dot-tw {
  background: linear-gradient(135deg, var(--nd-green), var(--nd-green-dark));
  box-shadow: 0 0 0 3px rgba(134,205,83,0.2);
}
.city-name {
  font-size: 1.6rem;
  font-weight: 800;
  color: var(--charcoal);
  letter-spacing: -0.5px;
  white-space: nowrap;
}
.city-en {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--gray-400);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  white-space: nowrap;
  margin-top: 4px;
}
.city-line {
  flex: 1;
  height: 1px;
  background: var(--gray-200);
}
 
 
/* ================================================
  # 카드 가로 스크롤
================================================ */
.card-scroll-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}
 
/* ================================================
  # 상품 카드
================================================ */
.asso-card {
  width: 280px;
  flex-shrink: 0;
  background: #fff;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--gray-200);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
}
.asso-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
}
 
@media (max-width: 640px) {
  .asso-card { width: calc(50% - 9px); }
}
@media (max-width: 400px) {
  .asso-card { width: 100%; }
}
 
/* 이미지 */
.card-pic {
  position: relative;
  overflow: hidden;
}
.card-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
  transition: transform 0.45s ease;
  border-radius: 0;
}
.asso-card:hover .card-img { transform: scale(1.06); }
 
/* 호버 오버레이 */
.card-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17,20,24,0.52);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
}
.asso-card:hover .card-overlay { opacity: 1; }
.overlay-cta {
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff;
  border: 2px solid var(--jin-lime);
  padding: 7px 18px;
  border-radius: 24px;
  background: rgba(200,224,58,0.15);
  letter-spacing: 0.3px;
}
 
/* 진에어 특가 리본 */
.special-ribbon {
  position: absolute;
  top: 12px;
  right: -1px;
  background: linear-gradient(90deg, var(--jin-lime-dark), var(--jin-lime));
  color: var(--charcoal);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  padding: 4px 12px 4px 10px;
  border-radius: 3px 0 0 3px;
  z-index: 3;
  box-shadow: -2px 2px 6px rgba(0,0,0,0.2);
}
.special-ribbon-tw {
  background: linear-gradient(90deg, var(--nd-green-dark), var(--nd-green));
  color: #fff;
}
 
/* 뱃지 */
.badge-wrap { position: absolute; top: 0; left: 0; z-index: 3; }
.badge1 {
  background: #e74c3c;
  opacity: 0.88;
  padding: 8px 12px;
  border-radius: 0 0 var(--radius-sm) 0;
}
.badge1-text { color: #fff; font-size: 0.88rem; font-weight: 700; padding: 0; }
 
/* 텍스트 바디 */
.card-body {
  padding: 0.9rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}
 
.pdtName {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.4;
  height: 2.66rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.35rem;
}
.pdtRemarks {
  font-size: 0.75rem;
  color: var(--gray-400);
  height: 1.1rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
}
.pdtRemarks i { color: var(--nd-green); font-size: 0.7rem; }
 
/* 가격 */
.card-price-wrap {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--gray-100);
}
.price-original {
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--gray-400);
  text-decoration: line-through;
  display: block;
  margin-bottom: 2px;
}
.price-final {
  font-size: 1.3rem;
  font-weight: 900;
  color: var(--charcoal);
  line-height: 1.2;
  background: linear-gradient(90deg, var(--charcoal), #333);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.price-won {
  font-size: 0.82rem;
  font-weight: 500;
  -webkit-text-fill-color: var(--gray-400);
  color: var(--gray-400);
  margin-left: 2px;
}
.preparing-wrap { display: flex; align-items: center; gap: 5px; }
.preparing-text { font-size: 0.82rem; font-weight: 600; color: var(--gray-400); }
.mbus-icon { width: 1.4rem !important; height: auto !important; }
</style>